(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-landing"] && !Shopify.designMode) return;
  try {
    
  const bootMlRails = () => {
    document.querySelectorAll('[data-ml-rail]').forEach((rail) => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('[data-ml-rail-track]');
      const prev = rail.querySelector('[data-ml-rail-prev]');
      const next = rail.querySelector('[data-ml-rail-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? (item.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / item.getBoundingClientRect().width)) : track.clientWidth;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        rail.toggleAttribute('data-scrollable', track.scrollWidth > track.clientWidth + 4);
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMlRails);
  } else {
    bootMlRails();
  }
  document.addEventListener('shopify:section:load', bootMlRails);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const countdown = (el) => {
      const end = Date.parse(el.dataset.mlBsCountdown);
      if (Number.isNaN(end)) return;
      const u = (k) => el.querySelector(`[data-unit="${k}"]`);
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) {
          el.hidden = true; // real deadline passed
          clearInterval(timer);
          return;
        }
        const sec = Math.floor(left / 1000);
        u('d').textContent = pad(Math.floor(sec / 86400));
        u('h').textContent = pad(Math.floor((sec % 86400) / 3600));
        u('m').textContent = pad(Math.floor((sec % 3600) / 60));
        u('s').textContent = pad(sec % 60);
        el.hidden = false;
      };
      const timer = setInterval(tick, 1000);
      tick();
    };

    const boot = () => {
      document.querySelectorAll('[data-ml-bs]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        root.querySelectorAll('[data-ml-bs-countdown]').forEach(countdown);

        const track = root.querySelector('[data-ml-bs-track]');
        const slides = [...root.querySelectorAll('[data-ml-bs-slide]')];
        const dots = [...root.querySelectorAll('[data-ml-bs-dot]')];
        if (slides.length < 2) return;

        let index = 0;
        let timer = null;
        const delay = Math.max(2, Number(root.dataset.delay) || 5) * 1000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const mark = (i) => {
          index = (i + slides.length) % slides.length;
          slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
          dots.forEach((d, n) => {
            d.classList.toggle('is-active', n === index);
            d.setAttribute('aria-selected', n === index ? 'true' : 'false');
          });
        };

        const go = (i) => {
          mark(i);
          track.scrollTo({ left: slides[index].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        };

        const stop = () => {
          clearInterval(timer);
          timer = null;
        };
        const start = () => {
          if (root.dataset.autoplay !== 'true' || reduced) return;
          stop();
          timer = setInterval(() => go(index + 1), delay);
        };

        root.querySelector('[data-ml-bs-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
        root.querySelector('[data-ml-bs-next]')?.addEventListener('click', () => { go(index + 1); start(); });
        dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.mlBsDot)); start(); }));

        // Keep dots in sync when the shopper swipes.
        let raf = 0;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            if (i !== index) mark(i);
          });
        }, { passive: true });

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        track.addEventListener('touchstart', stop, { passive: true });
        track.addEventListener('touchend', start, { passive: true });
        document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
        start();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-footer"] && !Shopify.designMode) return;
  try {
    
  // Columns are always open on desktop and collapsible on mobile.
  (() => {
    const mq = window.matchMedia('(min-width: 990px)');
    const sync = () => document.querySelectorAll('.ml-foot__col').forEach((d) => (d.open = mq.matches));
    sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-offer-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const start = (el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const end = Date.parse(el.dataset.mlCountdown);
      if (Number.isNaN(end)) return;
      const u = (k) => el.querySelector(`[data-unit="${k}"]`);
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) {
          el.hidden = true; // real deadline passed: hide the timer
          clearInterval(timer);
          return;
        }
        const sec = Math.floor(left / 1000);
        u('d').textContent = pad(Math.floor(sec / 86400));
        u('h').textContent = pad(Math.floor((sec % 86400) / 3600));
        u('m').textContent = pad(Math.floor((sec % 3600) / 60));
        u('s').textContent = pad(sec % 60);
        el.hidden = false;
      };
      const timer = setInterval(tick, 1000);
      tick();
    };
    const boot = () => document.querySelectorAll('[data-ml-countdown]').forEach(start);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
